export default __webpack_public_path__ + "static/media/img1.43f22146.png";